import React, { useState, useEffect, useRef, useCallback } from "react";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import classes from "./style.module.css";

import PrizePlaceHolder from "../../assets/images/pointsShop/pointsPlaceHolder.png";
import RCoin from "../../assets/images/icons/RCoin.png";

import { motion } from "framer-motion";
import appApi from "../../assets/utils/AppApi";
import errorHandler from "../../assets/utils/ErrorHandler";
import {
  convertToShamsi,
  convertToShamsiTime,
} from "../../assets/utils/ConvertToShamsi";
import Loading from "../../assets/containers/loadingDialog";
import { baseURL } from "../../assets/constants/baseUrl";
import { useNavigate } from "react-router-dom";
import NoResultAlter from "../../assets/components/UI/NoResultAlter";

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const PurchaseList = () => {
  const [items, setitems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totPages, setTotPages] = useState(1);
  const [page, setPage] = useState(1);
  const observer = useRef();
  const navigate = useNavigate();

  const getItems = async (page) => {
    setLoading(true);
    try {
      await appApi
        .get(`/pointshop/purchase/user/history?page=${page}&limit=10`)
        .then(({ data }) => {
          setTotPages(data.totalPages);
          setitems((prevItems) => [...prevItems, ...data.docs]);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getItems(page);
  }, [page]);

  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && page < totPages) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, page, totPages]
  );

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <div className={classes.contentContainer}>
          {!loading && items.length === 0 ? (
            <NoResultAlter className={"w-100  py-5 my-5"} />
          ) : (
            items.map((item, index) => (
              <motion.div
                className={classes.historyItem}
                key={item._id}
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={itemVariants}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                ref={index === items.length - 1 ? lastElementRef : null}
                onClick={() =>
                  navigate(`/awardReceipt/${item._id}?showMessage=false`)
                }
              >
                <img
                  src={
                    item.item.cover
                      ? `${baseURL}file/get/${item.item.cover}`
                      : PrizePlaceHolder
                  }
                  className={classes.historyImg}
                  alt="history imgage"
                />
                <div className={classes.historyContent}>
                  <div>
                    <div className={classes.dateContainer}>
                      <span>{convertToShamsiTime(item.createdAt)}</span>
                      <span className="mr-2">
                        {convertToShamsi(item.createdAt)}
                      </span>
                    </div>
                    <p className={classes.hitoryItemTitle}>{item.item.name}</p>
                    {/* <p
                      dangerouslySetInnerHTML={{
                        __html: item.item.description,
                      }}
                    ></p> */}
                    <p className="mt-3 mb-0 font-weight-light">ویترین جوایز</p>
                  </div>
                  <div className={classes.historyCoinContainer}>
                    <span>{item.item.price}</span>
                    <img src={RCoin} alt="coin" />
                  </div>
                </div>
              </motion.div>
            ))
          )}

          {loading && (
            <Loading
              className={"w-100 d-flex justify-content-center my-5 py-5"}
            />
          )}
        </div>
      </div>
    </AnimatedPageContainer>
  );
};

export default PurchaseList;
